var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomepageFeatureTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 113,
    height: 120,
    viewBox: "0 0 113 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Circle with a blue arrow pointing right and an orange arrow pointing left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C8DDE8",
    d: "M5.1 60c0 28.3 23 51.3 51.3 51.3 28.3 0 51.3-23 51.3-51.3 0-28.3-23-51.3-51.3-51.3-28.2 0-51.3 23-51.3 51.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#047BB7",
    d: "M80 47.4v16.2l31.8-31.8L80 0v16.2H0v31.2h80z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#EE684D",
    d: "M.7 88.2L32.5 120v-16.2h80V72.6h-80V56.4L.7 88.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageFeatureTransactions);
export default __webpack_public_path__ + "static/media/homepage-feature-transactions.0f3cbbfab9e75be219ede30fd212589f.svg";
export { ForwardRef as ReactComponent };